import { render, staticRenderFns } from "./Review_table.vue?vue&type=template&id=28f4c792&scoped=true"
import script from "./Review_table.vue?vue&type=script&lang=js"
export * from "./Review_table.vue?vue&type=script&lang=js"
import style0 from "./Review_table.vue?vue&type=style&index=0&id=28f4c792&prod&lang=css"
import style1 from "./Review_table.vue?vue&type=style&index=1&id=28f4c792&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4c792",
  null
  
)

export default component.exports